import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import IconButton from '@material-ui/core/IconButton';
import Button from "@material-ui/core/Button";
import CloseIcon from '@material-ui/icons/Close';
import LoopIcon from '@material-ui/icons/Loop';
import DeleteForever from '@material-ui/icons/DeleteForever';
import useStyles from "./styles";
import LoadingOrderClient from "../../api/loading-order";

function ModalOC({ loadingOrder, open, canResetOC, handleClose, handleClearOC, handleResetOC }) {
    const classes = useStyles();
    const URL_IMPORT = LoadingOrderClient.importLoadingOrderDocumentURL(loadingOrder.loading_order_number);

    const handleOnclose = () => {
        handleClose();
    }

    return (
        <div>
            <Modal
                className={classes.modalOC}
                aria-labelledby="Loading order"
                aria-describedby="Loading order"
                data-cy="loading-order-modal"
                id="loading-order-modal"
                open={open}
                onClose={handleOnclose}>
                <Fade in={open}>
                    <div className={classes.modalOCWrapper}>
                        <div className={classes.modalOCContainer}>
                            <div className={classes.modalOCHeader}>
                                <p className={classes.headerColor}>{loadingOrder.error ? 'Importação Manual de OC' : 'Buscar OC'}</p>
                                <IconButton
                                    variant="contained"
                                    color="primary"
                                    data-cy="close-btn"
                                    id="close-btn"
                                    onClick={handleOnclose}>
                                    <CloseIcon className={classes.headerColor} />
                                </IconButton>
                            </div>
                            <div className={classes.modalOCBody}>
                                {(loadingOrder.error && !loadingOrder.id) && (
                                    <>
                                        <h1>{loadingOrder.error?.message}</h1>
                                        <h3>{loadingOrder.error?.description}</h3>
                                    </>
                                )}


                                {(loadingOrder.id && !loadingOrder.error) &&
                                    <table className="striped-table"
                                       data-cy="oc-table-data"
                                       id="oc-table-data"
                                    >
                                        <tbody>
                                            <tr>
                                                <th>#OC</th>
                                                <th>#TN</th>
                                                <th>Placa Caminhão</th>
                                                <th>Data Planejada</th>
                                            </tr>
                                            <tr>
                                                <td>{loadingOrder.loading_order_number}</td>
                                                <td>{loadingOrder.tn}</td>
                                                <td>{loadingOrder.truck_license_plate}</td>
                                                <td>{loadingOrder.planed_collection_date}</td>
                                            </tr>
                                            <tr>
                                                <th colSpan={2}>Produto</th>
                                                <th colSpan={2}>Peso</th>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>{loadingOrder.product}</td>
                                                <td colSpan={2}>{loadingOrder.product_quantity}</td>
                                            </tr>
                                            <tr>
                                                <th colSpan={2}>Produtor Remetente</th>
                                                <th colSpan={2}>Address Number</th>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>{loadingOrder.farm_origin.description}</td>
                                                <td colSpan={2}>{loadingOrder.farm_origin.external_id}</td>
                                            </tr>
                                            <tr>
                                                <th colSpan={2}>Fazenda Expedidora</th>
                                                <th colSpan={2}>Address Number</th>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>{loadingOrder.farm.description}</td>
                                                <td colSpan={2}>{loadingOrder.farm.external_id}</td>
                                            </tr>
                                            <tr>
                                                <th colSpan={2}>Filial Origem</th>
                                                <th colSpan={2}>BP Number</th>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>{loadingOrder.branch_origin.name}</td>
                                                <td colSpan={2}>{loadingOrder.branch_origin.external_id}</td>
                                            </tr>
                                            <tr>
                                                <th colSpan={2}>Filial Destino</th>
                                                <th colSpan={2}>Address Number</th>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>{loadingOrder.branch.name}</td>
                                                <td colSpan={2}>{loadingOrder.branch.external_id}</td>
                                            </tr>
                                            <tr>
                                                <th colSpan={2}>Transportadora</th>
                                                <th colSpan={2}>Address Number</th>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>{loadingOrder.transporter.name}</td>
                                                <td colSpan={2}>{loadingOrder.transporter.external_id}</td>
                                            </tr>
                                            <tr>
                                                <th colSpan={2}>Motorista</th>
                                                <th colSpan={2}>CNH</th>
                                            </tr>
                                            <tr>
                                                <td colSpan={2}>{loadingOrder.driver.user.name}</td>
                                                <td colSpan={2}>{loadingOrder.driver.external_id}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                }
                            </div>
                            <div className={classes.modaFooter}>
                                <div>
                                    {
                                        canResetOC && (
                                            <>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className={`${classes.smButtonModal} clear`}
                                                    size="medium"
                                                    data-cy="reset-btn"
                                                    id="reset-btn"
                                                    onClick={handleClearOC}
                                                    startIcon={<LoopIcon />}>
                                                    Reiniciar
                                                </Button>
                                                {
                                                    (loadingOrder.can_download_pdf && loadingOrder.has_imported_oc_document) &&
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        className={`${classes.smButtonModal} clear`}
                                                        size="medium"
                                                        data-cy="remove-pdf-oc"
                                                        id="remove-pdf-oc"
                                                        onClick={handleResetOC}
                                                        startIcon={<DeleteForever />}>
                                                        Remover PDF da OC
                                                    </Button>
                                                }
                                                </>
                                        )
                                    }
                                </div>
                                <div>
                                    {
                                        loadingOrder.can_download_pdf &&
                                        <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.smButtonModal}
                                        data-cy="download-pdf-oc"
                                        id="download-pdf-oc"
                                        size="medium"
                                        target="_blank"
                                        href={URL_IMPORT}
                                        hide>
                                        Download PDF
                                    </Button>}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.smButtonModal}
                                        size="medium"
                                        data-cy="fechar-btn"
                                        onClick={handleOnclose}
                                        startIcon={<CloseIcon />}>
                                        Fechar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}

ModalOC.propTypes = {
    loadingOrder: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    canResetOC: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
};

export default ModalOC;